import { render, staticRenderFns } from "./CreateCourseInstructorDialog.vue?vue&type=template&id=98eac4de"
import script from "./CreateCourseInstructorDialog.vue?vue&type=script&lang=js"
export * from "./CreateCourseInstructorDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCourseInstructorDialog.vue?vue&type=style&index=0&id=98eac4de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports